import { useQuery } from "@apollo/client";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Drawer,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { LiaWalletSolid } from "react-icons/lia";
import { RxLink1 } from "react-icons/rx";
import {
  GET_ALL_REFERRALS,
  GET_TOTAL_REFERRALS,
  GET_TOTAL_REWARD_GIVEN,
} from "../../Utils/Queries";
import { AiOutlineClose } from "react-icons/ai";

const Referrals = () => {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => {
    setOpen(newOpen);
  };
  const { data: totalGiven, loading: givenLoader } = useQuery(
    GET_TOTAL_REWARD_GIVEN
  );

  const { data: totalReferrals, loading: totalLoading } =
    useQuery(GET_TOTAL_REFERRALS);

  const { data: allReferrals, loading: allLoading } =
    useQuery(GET_ALL_REFERRALS);

  const ALL_REFFERALS = allReferrals?.fetchAllReferrals?.items || [];

  const [selectedReferral, setSelectedReferral] = useState([]);

  console.log(ALL_REFFERALS);
  return (
    <>
      <Grid container spacing={2}>
        <Grid item md={6}>
          <Box
            sx={{
              bgcolor: "#fff",
              borderRadius: "4px",
              p: 3,
              boxSizing: "border-box",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", columnGap: 3 }}>
              <RxLink1 />
              <Typography sx={{ fontWeight: 500 }}>Total Referrals</Typography>
            </Box>

            {totalLoading ? (
              <CircularProgress size={30} sx={{ mt: 2 }} />
            ) : (
              <Typography sx={{ fontWeight: 700, fontSize: "22px", mt: 2 }}>
                {totalReferrals?.totalReferrals?.totalNoOfReferrals?.toLocaleString() ||
                  0}
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid item md={6}>
          <Box
            sx={{
              bgcolor: "#fff",
              borderRadius: "4px",
              p: 3,
              boxSizing: "border-box",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
              <LiaWalletSolid />
              <Typography sx={{ fontWeight: 500 }}>
                Total Rewards Given
              </Typography>
            </Box>
            {givenLoader ? (
              <CircularProgress size={30} sx={{ mt: 2 }} />
            ) : (
              <Typography sx={{ fontWeight: 700, fontSize: "22px", mt: 2 }}>
                $
                {totalGiven?.getTotalRewardsGiven?.totalRewardsGiven?.toLocaleString() ||
                  0}
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid item md={12}>
          <Box
            sx={{
              bgcolor: "#fff",
              borderRadius: "4px",
              p: 2,
              px: 3,
              boxSizing: "border-box",
            }}
          >
          <TableContainer>
            <Table>
              <TableHead sx={{ bgcolor: "#F7F6F6" }}>
                <TableRow sx={{ fontSize: "14px" }}>
                  <TableCell sx={{ border: "none" }}>Date Signup</TableCell>
                  <TableCell sx={{ border: "none" }}>Referrer</TableCell>
                  <TableCell sx={{ border: "none" }}>Referred User</TableCell>
                  <TableCell sx={{ border: "none" }}>Email</TableCell>
                  <TableCell sx={{ border: "none" }} align="center">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ALL_REFFERALS?.map((item, idx) => (
                  <TableRow sx={{ fontSize: "14px" }} key={idx}>
                    <TableCell>{formatDateTime(item?.createdAt)}</TableCell>
                    <TableCell>{`${item?.referrer?.firstName} ${item?.referrer?.lastName}`}</TableCell>
                    <TableCell>{`${item?.user?.firstName} ${item?.user?.lastName}`}</TableCell>
                    <TableCell>{`${item?.user?.email}`}</TableCell>
                    <TableCell align="center">
                      <Button
                        onClick={() => {
                          toggleDrawer(true);
                          setSelectedReferral(item);
                        }}
                        sx={{ bgcolor: "#F2F2F2", width: "100px" }}
                      >
                        View
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>

      <Drawer open={open} onClose={() => toggleDrawer(false)} anchor="right">
        <Box sx={{ width: "40vw", height: "100vh", bgcolor: "#fff", p: 3 }}>
          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "space-between",
              mt: 2,
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
              Referral Details
            </Typography>
            <IconButton onClick={() => toggleDrawer(false)}>
              <AiOutlineClose style={{ fontSize: "20px" }} />
            </IconButton>
          </Box>

          <Box
            sx={{
              mt: 4,
              borderRadius: "4px",
              border: "1px solid #F7F6F6",
              p: 2,
            }}
          >
            <Box>
              <Typography
                sx={{ color: "#666666", fontWeight: 300, fontSize: "12px" }}
              >
                Date
              </Typography>
              <Typography sx={{ fontWeight: 500, mt: 1 }}>
                {formatDateTime(selectedReferral?.createdAt)}
              </Typography>
            </Box>
            <Divider sx={{ my: 2 }} />
            <Box>
              <Typography
                sx={{ color: "#666666", fontWeight: 300, fontSize: "12px" }}
              >
                Referrer
              </Typography>
              <Typography
                sx={{ fontWeight: 500, mt: 1 }}
              >{`${selectedReferral?.referrer?.firstName} ${selectedReferral?.referrer?.lastName}`}</Typography>
            </Box>
            <Divider sx={{ my: 2 }} />
            <Box>
              <Typography
                sx={{ color: "#666666", fontWeight: 300, fontSize: "12px" }}
              >
                Referred User
              </Typography>
              <Typography
                sx={{ fontWeight: 500, mt: 1 }}
              >{`${selectedReferral?.user?.firstName} ${selectedReferral?.user?.lastName}`}</Typography>
            </Box>
            <Divider sx={{ my: 2 }} />
            <Box>
              <Typography
                sx={{ color: "#666666", fontWeight: 300, fontSize: "12px" }}
              >
                Email
              </Typography>
              <Typography
                sx={{ fontWeight: 500, mt: 1 }}
              >{`${selectedReferral?.user?.email}`}</Typography>
            </Box>
            <Divider sx={{ my: 2 }} />
            <Box>
              <Typography
                sx={{ color: "#666666", fontWeight: 300, fontSize: "12px" }}
              >
                Status
              </Typography>
              <Typography sx={{ fontWeight: 500, mt: 1 }}>{"PAID"}</Typography>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default Referrals;

const formatDateTime = (dateString) => {
  const date = new Date(dateString);

  const options = {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  return date.toLocaleString("en-US", options).replace(",", "");
};
